<template>
<el-row class="task-main">
  <top-nav></top-nav>
  <pdf ref="pdf" v-model="pdfVisible"></pdf>

  <div class="task-cover" v-show="coverVisible">
    <i class="el-icon-loading"></i>
  </div>

  <!--
  <el-col :xs="{span:24,offset:0}" :sm="{span:18,offset:3}" class="task-content" :style="taskContentStyle">
  -->
  <div :style="taskContentStyle">
    <!-- Task Parameters -->
    <div v-if="par" class="task-parameters">
      <div style="display:flex;flex-direction:row;align-items:center;margin-left:200px;margin-right:200px">
        <div style="flex:1 1">
          <div class="task-parameter-row">
            <div><b>Task ID</b>:</div>
            <div>{{`${task.id}`}}</div>
          </div>

          <div class="task-parameter-row">
            <div><b>Task Title</b>:</div>
            <div>{{`${task.title}`}}</div>
          </div>

          <!-- <div class="task-parameter-row">
            <div><b>Database</b>:</div>
            <div><span v-for="(db, i) in par.database" :key="i"> <a target="_blank" style="color:white" :href="databaseLink(db)">{{db}}</a>&nbsp; </span></div>
          </div> -->

          <div v-if="par.compound" class="task-parameter-row">
            <div><b>Number of Query Compounds</b></div>
            <div>{{compoundSmiles.length}}</div>
          </div>

          <div v-if="par.compound" class="task-parameter-row">
            <div>
              <select v-model="selectedCompoundIndex">
                <option v-for="iCompound in compoundSmiles.length" :value="iCompound-1" :key="iCompound">Compound {{iCompound}}</option>
              </select>
            </div>
            <div><textarea disabled :value="compoundSmiles[parseInt($store.state.route.params.icompound)]" style="resize:none;width:100%;margin-right:20px;background:none;border:none;color:white"></textarea></div>
            <!-- <div><div class="textarea" v-text="compounds[$store.state.iQueryCompound]"></div></div> -->
          </div>

          <div v-if="par.fpType" class="task-parameter-row">
            <div><b>Compound Similarity Metric</b>:</div>
            <div>{{`${par.fpType}`}}</div>
          </div>

          <div v-if="par.simCutoff" class="task-parameter-row">
            <div><b>FP2 Cutoff</b>: </div>
            <div>{{`${par.simCutoff}`}}</div>
          </div>

          <div class="task-parameter-row">
            <div><b>Fragmentation</b>:</div>
            <div>{{`${par.fragmentation ? 'Yes' : 'No'}`}}</div>
          </div>

          <div class="task-parameter-row" style="margin-top:50px"><i>Please <span style="cursor:pointer;color:white;text-decoration:underline" @click="filtersVisible=true"> click here </span> to filter the results.</i></div>
          <filters v-model=filtersVisible ref="filters" :task="task"></filters>
        </div> <!-- Task Panel -->

        <div style="flex:0 0 350px;display:flex;flex-direction:row;align-items:center;justify-content:center;background-color:white">
          <!-- <div v-if="loadingCompound" style="z-index:99;width:600px;height:400px;font-size:20px;text-align:center;vertical-align:middle;border:1px solid #eeeeee">Loading Structure<i class="el-icon-loading"></i></div>
          <div id="compound-canvas" width="400px" height="300px" style="box-shadow:inset 0px 0px 4px rgba(0,0,0,0.2);background:white"></div> -->
          <div><img height="200px" :src="smilesLink(compoundSmiles[parseInt($store.state.route.params.icompound)])"></div>
        </div>
      </div>
    </div> <!-- Task Parameters -->

    <div class="content-margin">
      <div style="display:flex;flex-direction:row" class="task-result-type-menu">
        <div :class="{'task-result-type-menu-item': true, 'menu-item-selected': type === $store.state.route.name}" v-for="(type, i) in resultTypes" @click="$router.push(type)" :key="i">
          {{ typeNames[type] }}
        </div>
      </div>

      <div>
        <keep-alive exclude="Statistics">
          <router-view/>
        </keep-alive>
      </div>
    </div>

  </div> <!-- task-content -->
</el-row> <!-- task-main -->
</template>

<script>
// import html2pdf from 'html2pdf.js'
import axios from 'axios'
import { bus } from '../bus.js'
import TopNav from './TopNav.vue'
import Filters from './Filters.vue'
import JsPDF from 'jspdf'
import Pdf from './Pdf.vue'
import { mapGetters } from 'vuex'
// import { Molecule } from 'openchemlib'

axios.defaults.headers.post['Content-Type'] = 'multipart/form-data'

export default {
  name: 'Task',

  data () {
    return {
      pdfVisible: false,
      resultTypes: ['Targets', 'Statistics', 'Compounds', 'Fragments'],
      typeNames: {
        'Targets': 'Targets',
        'Compounds': 'Compounds',
        'Fragments': 'Fragments',
        'Statistics': 'Target Statistics'
      },
      // resultCount: { 'Targets': 0, 'Compounds': 0, 'Processes': 0, 'Functions': 0, 'Fragments': 0 },
      compound: '',
      filtersVisible: false,
      coverVisible: false,
      sortOptions: [],
      loadingCompound: true
    }
  },

  components: {
    TopNav, Filters, Pdf
  },

  computed: {
    ...mapGetters([
      'compoundSmiles', 'par'
    ]),

    selectedCompoundIndex: {
      get () {
        return this.$store.state.route.params.icompound
      },

      set (value) {
        let route = this.$store.state.route
        this.$router.push({
          name: route.name,
          params: {
            id: route.params.id,
            icompound: value
          }
        })
        this.check()
      }
    },

    task () {
      if (this.$store.state.task) {
        return this.$store.state.task
      } else {
        return {}
      }
    },

    id () {
      return this.$route.params.id
    },

    taskContentStyle () {
      if (this.coverVisible) {
        return {
          position: 'fixed',
          left: '-100%',
          right: '100%'
        }
      } else {
        return {
        }
      }
    }
  },

  methods: {
    getCurrentRef () {
      return this.$refs[this.resultTypes[this.resultType].toLowerCase()]
    },

    databaseLink (db) {
      if (!db || db === 'CHEMBL') {
        return 'https://www.ebi.ac.uk/chembl'
      } else if (db === 'Metabolites') {
        return 'http://www.hmdb.ca/metabolites'
      } else {
        return 'https://zinc15.docking.org'
      }
    },

    smilesLink (smi) {
      let v = this
      let s = encodeURIComponent(smi)
      return `${v.$store.state.host}/dokhlab/actions/smiles2svg?smiles=${s}`
    },

    redirect (url) {
      window.location.href = url
    },

    openNewTab (url) {
      window.open(url, '_blank')
    },

    post (url, p, cb1 = () => {}, cb2 = () => {}) {
      let parts = [new Blob([JSON.stringify(p)], { type: 'application/json' })]
      let fileToSend = new File(parts, 'front-config.json', {
        type: 'application/json'
      })

      let formData = new FormData()

      formData.append('par', fileToSend)

      axios({
        method: 'post',
        url,
        data: formData,
        config: {headers: {'Content-Type': 'multipart/form-data'}},
        withCredentials: true
      }).then(response => {
        cb1(response)
      }).catch(error => {
        cb2(error)
      })
    },

    gen3D (srcData, loopCount, forceField = 'MMFF94') {
      let v = this
      var mol
      var gen = new v.openBabel.OB3DGenWrapper()
      console.log('check1')
      for (let i = 0, l = loopCount || 1; i < l; ++i) {
        mol = gen.generate3DStructureFromMolData(srcData, forceField)
        console.log('check2')
      }
      console.log('check3')
      return mol
    },

    check () {
      let v = this
      v.coverVisible = true
      v.$store.dispatch('fetchTask', {taskid: this.$route.params.id, icompound: this.$route.params.icompound}).then(response => {
        v.coverVisible = false
      }).catch(error => {
        console.log(error)
        v.coverVisible = false
      })
    },

    savePdf () {
      let v = this

      v.pdfVisible = true
      v.$refs.pdf.update(v.task.results)

//      html2pdf(document.getElementById('task-report'), {margin: 1, jsPDF: {unit: 'mm', format: [750, 1000]}, filename: `Task-${this.id}-report.pdf`})
//      console.log(JsPDF)
//      let doc = new JsPDF()
//      doc.setFontSize(50)
//      doc.text('Targets', 105, 40, { align: 'center' })
//      doc.addImage(document.getElementById('summary-target-names').toDataURL('image/png'), 'PNG', 10, 65, 200, 100)
//
//      doc.addPage()
//      doc.setFontSize(50)
//      doc.text('Target Organisms', 105, 40, { align: 'center' })
//      doc.addImage(document.getElementById('summary-target-organisms').toDataURL('image/png'), 'PNG', 10, 65, 200, 100)
//
//      for (let i = 0; i < v.task.results.length; i++) {
//        doc.addPage()
//        doc.setFontSize(50)
//        doc.text(`Compound ${i + 1}`, 105, 40, { align: 'center' })
//      }
//
//      doc.addPage()
//      doc.text('Processes', 20, 20)
//      doc.addPage()
//      doc.text('Involved Functions', 20, 20)
//      doc.addPage()
//      doc.text('Fragments', 20, 20)
//      doc.save(`Task-${this.id}-report.pdf`)
    }
  },

  mounted () {
    let v = this

    // v.smilesPromise = v.$store.state.smilesDrawerPromise.then(() => {
    //   v.smilesDrawer = new window.SmilesDrawer.Drawer({ width: 200, height: 200 })
    // })
    v.check()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../styles/theme.scss";

.content-margin {
  margin-left: 200px;
  margin-right: 200px;
}

.task-cover {
  font-size: 80px;
  width: 100%;
  height: 600px;
  line-height: 600px;
  text-align: center;
}

.task-parameters {
  background-color: $theme-color;
  color: white;
  padding: 50px 0px;
  margin: 10px 0px;
}

.task-parameter-row {
  display: flex;
  flex-direction: row;
  margin: 10px 10px 10px 0px;
}

.task-parameter-row >div {
  width: 50%;
}

.task-main {
 font-size: 16px;
 color: $font-grey;
}

.task-result-type-menu {
  font-size: 20px;
  font-weight: 600;
  /*
  border-bottom: 1px solid lighten($font-grey, 50%);
  */
  margin-bottom: 20px;
}

.task-result-type-menu-item {
  box-sizing: content-box;
  padding: 30px 20px 30px 20px;
  cursor: pointer;
  border-bottom: 5px solid white;
  text-align: center;
}

.task-result-type-menu-item.menu-item-selected {
  border-bottom: 5px solid $theme-color;
}

.results-menu-count {
  color: black;
  margin-right: 40px;
  font-weight: 450;
  margin-bottom: 20px;
}

</style>
